export function onClick() {
  window.location.reload(true)
}
